import { useRef, useState } from "react";
import "../../styles/UserDashboard/disputeModal.scss";
import { useSelector } from "react-redux";
import axios from "axios";

export default function DisputeModal({open, setOpen}) {
    const auth = useSelector((state) => state.auth);
  
    const mediaRef = useRef(null);
  
    const [uplaodLoading, setUploadLoading] = useState("");
    const [disputeImage, setDisputeImage] = useState("");

      const clickFileUpload = (e, documentTypeSent) => {
        setUploadLoading(true);
    
        let files = e.target.files;
    
        const fileToUri = (file, cb) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            cb(null, reader.result);
          };
          reader.onerror = function (error) {
            cb(error, null);
          };
        };
    
        if (files) {
          for (let i = 0; i < files.length; i++) {
            fileToUri(files[0], (err, result) => {
              if (result) {
                axios
                  .post(
                    `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                    {
                      media_type: "docx",
                      folder: "word_documents",
                      user_id: auth?.userInfo?.id,
                      contents: [result],
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${auth ? auth.token : ""}`,
                      },
                    }
                  )
                  .then((response) => {
                    setDisputeImage(response?.data?.body?.data[0]);
    
                    setUploadLoading(false);
                  })
                  .catch((err) => {
                    setUploadLoading(false);
                  });
              }
            });
          }
        }
      };

      const handleModalClose = (e) => {
        if (e.target.classList.contains("dispute-modal")) {
          setOpen(false);
        }
      };
  
  return (
    open && 
    <div className="dispute-modal" onClick={handleModalClose}>
      <div className="dispute-modal__inner">
        <div className="dispute-modal__inner__title">Dispute Transaction</div>
        <form action="">
          <label htmlFor="">Transaction ID</label>
          <input type="text" placeholder="ND-19UTOSZ" />
          <label htmlFor="">Issue Type</label>
          <input type="text" placeholder="Enter the subject" />
          <label htmlFor="">Description</label>
          <textarea
            name=""
            id=""
            placeholder="Give a detailed explanation of the issue"
          ></textarea>
          <label className="kyc_input_flex">
                  <div className="kyc_input">
                    {uplaodLoading
                      ? "Loading..."
                      : disputeImage?.length > 0
                      ? "Document uploaded"
                      : "Click to choose file to upload"}
                  </div>
                  <div className="kyc_upload_button">Browse Files</div>
                  {!disputeImage?.length > 0 && (
                    <input
                      type="file"
                      multiple
                      // accept='video/*'
                      accept="application/pdf"
                      name="disputeImage"
                      id="disputeImage"
                      hidden
                      onChange={(e) => {
                        clickFileUpload(e, "disputeImage");
                      }}
                      ref={mediaRef}
                    />
                  )}
                </label>

                {disputeImage?.length <= 0 && (
                  <div
                    className="drag_drop"
                    id="drag_drop"
                    data-docType="disputeImage"
                  >
                    {uplaodLoading ? (
                      ""
                    ) : (
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_135_4259)">
                          <path
                            d="M38.7 20.08C38.0282 16.6754 36.1952 13.6097 33.5141 11.4065C30.8331 9.20327 27.4702 7.99922 24 8C18.22 8 13.2 11.28 10.7 16.08C7.76047 16.3977 5.04201 17.7904 3.06698 19.9906C1.09194 22.1909 -0.000343404 25.0434 8.09855e-08 28C8.09855e-08 34.62 5.38 40 12 40H38C43.52 40 48 35.52 48 30C48 24.72 43.9 20.44 38.7 20.08ZM28 26V34H20V26H14L23.3 16.7C23.7 16.3 24.32 16.3 24.72 16.7L34 26H28Z"
                            fill="#667185"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_135_4259">
                            <rect width="48" height="48" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                    <div>
                      {uplaodLoading
                        ? "Loading..."
                        : disputeImage?.length > 0
                        ? "Document uploaded"
                        : "Drop and drag files here"}
                    </div>
                  </div>
                )}

                <button className="dispute-modal__inner__button"
                onClick={() => setOpen(false)}
                >Submit</button>
        </form>
      </div>
    </div>
  );
}
